// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import moment from 'moment'

// instead of creating custom formatters for these cells,
// just put the values of interest at the top level of the object.
const prepData = arr => arr.map(d => {
  const {
    diameter,
    diameterUS,
    hiFrequency,
    loFrequency,
    rpeDate,
    rpeNumber,
  } = d

  d.diameterMandFt = diameter ? `${diameter} / ${diameterUS.toFixed(2)}` : 'n/a'
  d.frequencyRange = hiFrequency ? `${loFrequency} - ${hiFrequency}` : 'n/a'
  d.patternDate = rpeDate === null ? 'n/a' : moment(rpeDate).format('YYYY/MM/DD')
  d.rpeNumber = rpeNumber || 'n/a'
  d.uniqueId = 'antennaCode' // so that DataTable can create a unique id
  return d
})

export default prepData
